import { clearChemicalsData } from '@/redux/chemicals/chemicals.slice';
import { clearDrugsData } from '@/redux/drugs/drugs.slice';
import { setMarkersData } from '@/redux/markers/markers.slice';
import { store } from '@/redux/store';
import { clearSearchModelElements } from '@/redux/modelElements/modelElements.slice';
import { ElementName } from '@/services/pluginsManager/pluginsManager.types';
import { PluginsEventBus } from '@/services/pluginsManager/pluginsEventBus';

const SEARCH_ELEMENTS: ElementName[] = ['content', 'chemicals', 'drugs'];

export const clearAllElements = (elements: ElementName[]): void => {
  const { dispatch } = store;

  if (elements.includes('content')) {
    dispatch(clearSearchModelElements());
  }

  if (elements.includes('chemicals')) {
    dispatch(clearChemicalsData());
  }

  if (elements.includes('drugs')) {
    dispatch(clearDrugsData());
  }

  if (elements.includes('marker')) {
    dispatch(setMarkersData([]));
  }

  // markers are not part of the search, so clearing them alone is not a search reset
  if (SEARCH_ELEMENTS.some(element => elements.includes(element))) {
    PluginsEventBus.dispatchEvent('onClear');
  }
};
